import { LoaderFunction } from "react-router-dom";

import ContentRequests from "@/api/content/content.requests.ts";
import { queryClient } from "@/api/query-client.tsx";
import { CONTENT_KEYS } from "@/hooks/api/content.hooks.ts";
import { lang } from "@/utils/funcs.ts";

export const countryDetailLoader: LoaderFunction = ({ params }) => {
  const { id } = params as { id: string };
  const countryCache = queryClient.getQueryData(CONTENT_KEYS.content({ lang, limit: 30, country: id }));
  if (countryCache) return countryCache;

  return queryClient.fetchInfiniteQuery({
    queryKey: CONTENT_KEYS.content({ lang, limit: 30, country: id }),
    queryFn: ({ pageParam = 0 }) => ContentRequests.getContent({ limit: 30, offset: pageParam * 30, country: id }),
    initialPageParam: 0,
    staleTime: 1000 * 60 * 15,
  });
};
